import { isAuthenticated } from '../guards/auth';

export default [
  {
    path: '/check/:id?',
    name: 'check',
    meta: { moduleId: 'check' },
    component: () => import(/* webpackChunkName: "search" */ '@/views/check/Search.vue'),
    beforeEnter: isAuthenticated,
  },
  {
    path: '/check/detail/:id',
    name: 'check.detail',
    meta: { moduleId: 'check' },
    component: () => import(/* webpackChunkName: "detail" */ '@/views/check/Detail.vue'),
    beforeEnter: isAuthenticated,
  },
];
